<template>
  <v-row id="confirmBar" justify="center" dense no-gutters>
    <v-dialog v-model="dialog" max-width="550px">
      <v-card class="confirmBar">
        <v-card-title> Message </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense no-gutters>
              <v-col cols="1">
                <v-icon size="25" color="#181819">mdi-help-circle-outline</v-icon>
              </v-col>
              <v-col style="min-height: 50px">
                <v-row v-for="(message, index) in getConfirmMessage().value" :key="index" dense no-gutters>
                  <label class="confirmLabel">{{ message }}</label>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col offset="6">
                <v-btn ref="okBtn" x-small small class="default" @click="ok"> OK </v-btn>
                <v-btn x-small small class="cancelBtn" @click="cancel"> CANCEL </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import { clearMessage, getConfirmMessage, setConfirmType } from '@/utils/messageUtils';
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  name: 'ConfirmBar',
  setup() {
    const okBtn = ref<any>(null);
    const dialog = ref(false);
    function ok() {
      clearMessage();
      setConfirmType('OK');
    }
    function cancel() {
      clearMessage();
      setConfirmType('CANCEL');
    }
    watch(
      () => getConfirmMessage().value,
      (newValue) => {
        if (newValue.length > 0) {
          dialog.value = true;
          okBtn.value?.$el?.focus();
        } else {
          dialog.value = false;
        }
      },
      { deep: true, immediate: true },
    );

    return {
      ok,
      okBtn,
      cancel,
      dialog,
      getConfirmMessage,
    };
  },
});
</script>

<style scoped lang="scss">
.confirmBar .v-card__title {
  font-size: 14px !important;
  max-height: 40px;
  background-color: #0072ce;
  color: #ffffff;
  padding: 5px 0px 5px 5px !important;
  font-weight: 600 !important;
}
.confirmBar .v-card__text {
  font-size: 13px !important;
  padding: 0px 0px 0px 15px !important;
  font-weight: bold !important;
}
.default {
  background: #0072ce !important;
  color: #fff !important;
  width: 100px;
  margin-left: 2px;
  font-size: 12px !important;
  height: 28px !important;
  font-weight: bold !important;
}
.cancelBtn {
  background: #929399 !important;
  color: #fff !important;
  width: 100px;
  margin-left: 2px;
  font-size: 12px !important;
  height: 28px !important;
  font-weight: bold !important;
}
.confirmLabel {
  font-weight: bold;
  color: #181819;
}
</style>
